import React, { useState } from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import { useNavigate, useLocation } from "react-router-dom";
import { useSignup } from "../context/signUpContext";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck } from "@fortawesome/free-solid-svg-icons";

const VerificationPage = () => {
  const location = useLocation();
  const selectedPlan = location.state?.selectedPlan;
  const navigate = useNavigate();
  const { setCompletedSteps } = useSignup();

  const [code, setCode] = useState(["", "", "", "", "", ""]);
  const emailFromState = location.state?.email || "";
  const [email, setEmail] = useState(emailFromState);
  const [error, setError] = useState("");

  const handleCodeChange = (e, index) => {
    const newCode = [...code];
    newCode[index] = e.target.value;
    setCode(newCode);

    if (e.target.value && index < 5) {
      document.getElementById(`code-input-${index + 1}`).focus();
    }
  };

  const handleNext = async () => {
    const verificationCode = code.join("");

    try {
      const response = await fetch("https://api.theonlysale.com/api/verify-code", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email, code: verificationCode }),
      });

      const responseData = await response.json();

      if (response.ok) {
        setCompletedSteps((prev) => ({ ...prev, verification: true }));
        navigate("/verification-successful", { state: { selectedPlan } });
      } else {
        setError(responseData.message || "Failed to verify code");
      }
    } catch (error) {
      console.log("Error:", error);
      setError("Error verifying the code");
    }
  };

  const handlePrev = () => {
    navigate("/account-info", { state: { selectedPlan } });
  };

  return (
    <>
      <Header />
      <div className="flex flex-col min-h-screen">
        <main className="flex-grow flex items-center justify-center bg-white dark:bg-gray-900">
          <div className="flex flex-col max-w-4xl w-full bg-white rounded-lg shadow-lg overflow-hidden md:flex-row">
            <div className="bg-blue-600 dark:bg-blue-800 p-8 flex flex-col justify-between text-white w-full md:w-1/3">
              <div>
                <h2 className="text-3xl font-semibold mb-6">
                  Your selected plan
                </h2>
                {selectedPlan ? (
                  <>
                    <h3 className="text-2xl font-bold">{selectedPlan.title}</h3>
                    <p className="text-lg">{selectedPlan.price}/month</p>
                    <ul className="mt-4 space-y-2">
                      {selectedPlan.features.map((feature, index) => (
                        <li key={index} className="flex items-center">
                          <FontAwesomeIcon
                            icon={faCheck}
                            className="w-6 h-6 mr-2"
                          />
                          {feature}
                        </li>
                      ))}
                    </ul>
                  </>
                ) : (
                  <p>No plan selected.</p>
                )}
              </div>
              <div className="mt-4">
                <a href="#" className="text-white text-sm underline">
                  Go back
                </a>
              </div>
            </div>

            <div className="bg-white w-full md:w-2/3 p-6 md:p-12 flex flex-col justify-between dark:bg-gray-800">
              <div className="space-y-6">
                <div className="flex flex-wrap items-center justify-between">
                  <div className="flex items-center text-lg font-semibold text-blue-600 dark:text-blue-400">
                    <FontAwesomeIcon
                      icon={faCheck}
                      className="mr-2"
                      style={{
                        color: "#4964ED",
                        width: "20px",
                        height: "20px",
                      }}
                    />
                    Personal info
                  </div>
                  <div className="flex items-center text-lg font-semibold text-blue-600 dark:text-blue-400">
                    <FontAwesomeIcon
                      icon={faCheck}
                      className="mr-2"
                      style={{
                        color: "#4964ED",
                        width: "20px",
                        height: "20px",
                      }}
                    />
                    Account info
                  </div>
                  <div className="flex items-center text-lg font-semibold text-blue-600 dark:text-blue-400">
                    <FontAwesomeIcon
                      icon={faCheck}
                      className="mr-2"
                      style={{
                        color: "#4964ED",
                        width: "20px",
                        height: "20px",
                      }}
                    />
                    Payment
                  </div>
                  <span className="text-gray-400 dark:text-gray-500">
                    Confirmation
                  </span>
                </div>
              </div>
              <h3 className="text-2xl font-semibold mb-4 text-black dark:text-white">
                Verify your email address
              </h3>
              <p className="mb-6 dark:text-gray-400 text-gray-600">
                We emailed you a six-digit code to{" "}
                <span className="font-medium">{email}</span>. Enter the code
                below to confirm your email address.
              </p>

              {error && <p className="text-red-500 mb-4">{error}</p>}
              <div className="grid grid-cols-6 gap-2 mb-6">
                {code.map((digit, index) => (
                  <input
                    key={index}
                    id={`code-input-${index}`}
                    type="text"
                    maxLength="1"
                    value={digit}
                    onChange={(e) => handleCodeChange(e, index)}
                    className="w-full px-4 py-2 border rounded-lg text-center focus:outline-none focus:ring-2 focus:ring-blue-600"
                  />
                ))}
              </div>
              <p className="text-gray-500 mb-6">
                Make sure to keep this window open while you check your inbox.
              </p>
              <div className="flex flex-col md:flex-row justify-between">
                <button
                  type="button"
                  className="mb-2 md:mb-0 px-4 py-2 text-sm font-medium text-gray-700 bg-gray-200 rounded-lg hover:bg-gray-300"
                  onClick={handlePrev}
                >
                  Prev: Account Info
                </button>
                <button
                  type="submit"
                  className="px-6 py-2 text-sm font-medium text-white bg-blue-600 rounded-lg hover:bg-blue-700"
                  onClick={handleNext}
                >
                  Verify account
                </button>
              </div>
            </div>
          </div>
        </main>
      </div>
      <Footer />
    </>
  );
};

export default VerificationPage;
